import React, { useEffect, useState } from 'react';
import './WeekForm.css';
import { Button } from 'react-bootstrap';

const WeekForm = ({ showForm , setShowForm , onAddWeek , editData}) => {
  // const [showForm, setShowForm] = useState(false);
  const [weekName, setWeekName] = useState('');
  const [description, setDescription] = useState('');
  const [weekSequenceNo, setWeekSequenceNo] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onAddWeek({ title: weekName, description , weekNumber :weekSequenceNo , _id : editData?._id});
    setWeekName('');
    setDescription('');
    setShowForm(false);
  };

  useEffect(() => {
    if (editData) {
      setWeekName(editData.title);
      setDescription(editData.description);
      setWeekSequenceNo(editData.weekNumber);
    }
  else {
      setWeekName('');
      setDescription('');
      setWeekSequenceNo('');
    }
  }, [editData]);

  return (
    <>


      {showForm && (
        <div className="modal-overlay-week-form" role="presentation">
          <div
            className="modal-content-education"
            role="dialog"
            aria-modal="true"
            aria-labelledby="week-form-title"
          >
            <div className="modal-header edit-week-header">
              <div>
                <h2 id="week-form-title">{editData ? 'Edit week' : 'Add new week'}</h2>
                <p>{editData ? 'Update this week’s details' : 'Create the next education week'}</p>
              </div>
              <button
                type="button"
                className="close-btn"
                onClick={() => setShowForm(false)}
                aria-label="Close week dialog"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form className="week-form" onSubmit={handleSubmit}>
              <div className="week-form-body">
                <div className="form-group">
                  <label htmlFor="week-name">Week name</label>
                  <input
                    id="week-name"
                    type="text"
                    value={weekName}
                    onChange={(e) => setWeekName(e.target.value)}
                    placeholder="Week 1"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="week-sequence">Week sequence number</label>
                  <input
                    id="week-sequence"
                    type="number"
                    min="1"
                    inputMode="numeric"
                    value={weekSequenceNo}
                    onChange={(e) => setWeekSequenceNo(e.target.value)}
                    placeholder="1"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="week-description">Description</label>
                  <textarea
                    id="week-description"
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Brief description of this week's focus..."
                  />
                </div>
              </div>
              <div className="form-actions">
                <Button type="button" onClick={() => setShowForm(false)} className="btn outlined-btn">
                  Cancel
                </Button>
                <Button type="submit" className="filled-btn">
                  {editData ? 'Update Week' : 'Add Week'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default WeekForm;
